import * as Yup from "yup";

const schema = Yup.object().shape({
  fullname: Yup.string().required("Họ và tên là bắt buộc!").max(50, "Họ và tên không được vượt quá 50 ký tự"),
  email: Yup.string().email("Định dạng email không hợp lệ").required("Email là bắt buộc!"),
  phoneNumber: Yup.string()
    .required("Số điện thoại là bắt buộc!")
    .matches(/^[0-9]+$/, "Số điện thoại không hợp lệ"),
  message: Yup.string().required("Nội dung là bắt buộc!").max(1000, "Nội dung không được vượt quá 1000 ký tự"),
});

export default schema;
